import type React from 'react'
import type { JSX } from 'react'
import type { IPrimaryButtonProps } from 'atoms/Button/Templates'
import type { ITextBlockDescriptionForSpecialRowProps } from 'blocks/TextBlock/Templates'
import type { IContainerDescriptionProps } from '../ContainerDescription'

import { PrimaryButton } from 'atoms/Button/Templates'
import { TextBlockDescriptionForSpecialRow } from 'blocks/TextBlock/Templates'
import { ContainerDescription } from '../ContainerDescription'
import { ContainerDescriptionRowGap } from '../ContainerDescription.h'

export interface IContainerDescriptionForSpecialRowProps extends Omit<
  IContainerDescriptionProps,
  'children'
> {
  children?: React.ReactNode
  title?: ITextBlockDescriptionForSpecialRowProps['title']
  description?: ITextBlockDescriptionForSpecialRowProps['description']
  buttonTitle?: IPrimaryButtonProps['title']
  onSeeAllClick?: () => void
}

export const ContainerDescriptionForSpecialRow = ({
  title = '',
  description = '',
  buttonTitle = '',
  rowGap = ContainerDescriptionRowGap.INDENT_40,
  children,
  onSeeAllClick,
  ...rest
}: IContainerDescriptionForSpecialRowProps): JSX.Element => (
  <ContainerDescription rowGap={rowGap} {...rest}>
    <TextBlockDescriptionForSpecialRow
      title={title}
      description={description}
      width={100}
    />
    {children ? (
      children
    ) : buttonTitle ? (
      <PrimaryButton onClick={onSeeAllClick} title={buttonTitle} />
    ) : null}
  </ContainerDescription>
)

ContainerDescriptionForSpecialRow.displayName =
  'ContainerDescriptionForSpecialRow'
